export enum TOAST_TYPE {
  INFO = "info",
  DANGER = "danger",
  SUCCESS = "success",
}

export interface IToast {
  toastId: string;
  text?: string;
  type: TOAST_TYPE;
  timeout?: number;
}

export default class Toast implements IToast {
  toastId!: string;
  text?: string;
  type!: TOAST_TYPE;
  timeout?: number;

  constructor(data: IToast) {
    for (var property in data) {
      if (data.hasOwnProperty(property))
        (<any>this)[property] = (<any>data)[property];
    }
  }
}
